<template>
    <path fill-rule="evenodd" d="M6.931 20.003c-.066.005-.139.004-.206.023-.534.15-.838.72-.686 1.252.152.532.7.834 1.236.683.534-.15.838-.697.686-1.23-.133-.465-.563-.763-1.03-.728zM1 2.57V21.43C1 22.294 1.633 23 2.412 23h9.176c.783 0 1.412-.701 1.412-1.571V2.57C13 1.706 12.367 1 11.588 1H2.412C1.629 1 1 1.701 1 2.571zM0 2.4C0 1.075.984 0 2.21 0h9.58C13.01 0 14 1.078 14 2.4v19.2c0 1.325-.984 2.4-2.21 2.4H2.21C.99 24 0 22.922 0 21.6V2.4zM13 18v1H1v-1h12zm-1-3v2H2v-2h10zm0-3v2H2v-2h10zm0-3v2H2V9h10zm0-3v2H2V6h10zm0-3v2H2V3h10z"/>
</template>

<script>
export default {
    name: 'offerWallIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 14 24');
    }
};
</script>
